import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    currTemp: {
        fontWeight: 700,
    },
    dataTable: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        fontSize: theme.typography.size.xl,
        tableLayout: 'fixed',
        width: '100%',
    },
    dataTableWrapper: {
        height: '100%',
        overflow: 'hidden',
    },

    demoBanner: {
        width: '100%',
        height: '100%',
    },
    date: {
        paddingLeft: '2px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },

    demoTitle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center',
        fontSize: theme.spacing(11),
        opacity: 0.2,
        zIndex: 1, // Ensure the title is above the image
    },
    demoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '3.5rem',
        fontWeight: theme.typography.fontWeightRegular,
    },

    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
    },
    singleValue: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        fontSize: theme.spacing(13),
        textAlign: 'center',
    },
}));

export default useStyles;
